export default __webpack_public_path__ + "static/media/UI-UX.78cfc23b.png";